import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatTable } from '@angular/material/table';
import * as CryptoJS from 'crypto-js';
import html2canvas from 'html2canvas';
import { ToastrService } from 'ngx-toastr';
import { MaterialModule } from 'src/app/material.module';
import { SubjectTable } from 'src/app/modules/evl/models/subject-table';
import { environment } from 'src/environments/environment';
import { AppBreadcrumbComponent } from "../../../../layouts/full/shared/breadcrumb/breadcrumb.component";
import { EvlService } from '../../services/evl.service';

@Component({
  selector: 'app-qr-generator',
  imports: [
    FormsModule,
    CommonModule,
    MaterialModule,
    AppBreadcrumbComponent
  ],
  templateUrl: './qr-generator.component.html',
  styleUrl: './qr-generator.component.scss'
})
export class QrGeneratorComponent implements AfterViewInit {
  @ViewChild(MatTable, { static: true }) table: MatTable<any> =
    Object.create(null);
  base64QrCode: any;

  constructor(private evlService: EvlService,
    private toast: ToastrService
  ) { }

  baseUrl = environment.frontUrl
  secretKey = 'Nj5mW';
  generatedurl: string = "";
  url: string = "";
  allTables: SubjectTable[] = [];
  selectedTable: any;
  fetchedNames: any[] = [];
  selectedName: any;
  selectedTableId: number = 0;
  qrCodeImageUrl: any;
  qrCodeImageBlob: Blob = new Blob([]);
  encryptedurl: string = ""
  loading: boolean = false


  ngAfterViewInit(): void {
    this.getEvaluationsList();
  }

  getEvaluationsList(): void {
    this.evlService.GetEvaluationsList().subscribe(response => {
      this.allTables = response.data.filter((item: any) => item.nameEn != 'Employee' && item.isActive == true)
        .map((item: any) => ({
          nameEn: item.nameEn,
          nameAr: item.nameAr,
          id: item.id,
          controllerName: item.controllerName,
          typeField: item.typeField,
          typeId: item.typeId,
          isActive: item.isActive
        }));
    })
  }

  onTableSelect(event: any): void {
    const selectedApi = this.selectedTable.controllerName;
    const TypeId = this.selectedTable.typeId
    this.qrCodeImageUrl = null
    if (selectedApi) {
      this.evlService.getTableData(selectedApi, TypeId).subscribe(
        (response) => {
          this.fetchedNames = response.data.map((item: any) => ({
            nameEn: item.nameEn,
            id: item.id,
            nameAr: item.nameAr
          }));
        },
        (error) => {
        }
      );
    }
  }

  generateQr() {
    this.loading = true;
    this.qrCodeImageUrl = null;

    this.selectedTableId = this.selectedTable.id;
    this.generatedurl = `${this.baseUrl}/user-evaluation/evaluation/${this.selectedTableId}/${this.selectedName.id}`;
    this.encryptedurl = this.encryptAndReplaceUrl(this.generatedurl);

    this.evlService.generateQr(this.encryptedurl).subscribe(
      (response: Blob) => {
        if (!response || response.size === 0) {
          alert('Error: Empty QR code received.');
          this.loading = false;
          return;
        }


        setTimeout(() => {
          this.qrCodeImageBlob = response;
          this.qrCodeImageUrl = URL.createObjectURL(response);
          this.loading = false; // ✅ Now it's ready
        }, 500); // A half-second feels slick
      },
      (error) => {
        alert('Oops! Something went wrong. Please try again.');
        this.loading = false;
      }
    );
  }

  printQr() {
    const printWindow = window.open('', 'Stars neon Evaluation QR Code');

    if (printWindow) {
      // Using an arrow function to ensure 'this' refers to the component
      printWindow.document.write(`
        <html>
        <head>
          <title></title>
          <style>
           @page { margin: 0; }
            body { text-align: center; padding: 20px;  }
          
          </style>
        </head>
        <body id="capture-content">
       <nav style="display:flex; justify-content:center; margin-top:20px;">
            <img src="${location.origin}/assets/images/logos/logo-light.svg" alt="Logo" style="width: 270px;">
          </nav>
          <div style="margin-top: 70px !important;" >
          <h2 style="font-size:26px">امسح الرمز لمشاركة تقييمكم</h2>
            <h2 style="font-size:26px">Scan the QR Code To Share Your Feedback</h2>
           <p style="font-size:22px">${this.selectedName.nameAr}</p>
            <p style="font-size:22px">${this.selectedName.nameEn}</p>
            <img src="${this.qrCodeImageUrl}" alt="QR Code" style="width:500px ; height:500px"/>
            <p class="text-muted" style="font-size:22px">نود سماع رأيك! لا تتردد في مشاركة أفكارك معنا.</p>
            <p class="text-muted" style="font-size:22px">We’d love to hear your feedback! Feel free to share your thoughts with us.</p>
          </div>
          <script>
            window.onload = function() {
              window.print();
  
              // Capture and save the QR code after the page has loaded
              window.setTimeout(function() {
                // Passing 'this' as a parameter to access the Angular method
                window['captureAndSave']();
                setTimeout(() => { window.close(); }, 500);
              }, 1000);
            };
          </script>
        </body>
        </html>
      `);

      printWindow.document.close();

      // Attach a method to the printWindow to capture and save the image after printing
      (printWindow as any)['captureAndSave'] = () => {
        const contentToCapture = printWindow.document.getElementById("capture-content");

        if (contentToCapture) {
          html2canvas(contentToCapture).then(canvas => {
            // Convert the canvas to a base64 encoded PNG image
            const base64Image = canvas.toDataURL('image/png');

            if (base64Image) {
              // Send the captured base64 image string to save
              this.base64QrCode = base64Image;  // Store base64 string
              this.saveQrImage();  // Now call saveQrImage after the image is captured
            } else {
            }

          }).catch(error => {
          });
        } else {
        }
      };
    }
  }

  saveQrImage() {
    if (this.base64QrCode) {

      this.evlService.saveQrImage(this.base64QrCode).subscribe(response => {
        this.toast.success("QR code saved !", '');
      }, error => {
      });
    } else {
    }
  }

  encryptAndReplaceUrl(url: string): string {
    // Extract everything after '/evaluation/'
    const parts = url.split('/evaluation/')[1];
    if (!parts) {
      return url;
    }

    // Encrypt the original string without modifying it
    const encryptedData = CryptoJS.AES.encrypt(parts, this.secretKey).toString();

    // Now replace slashes in the encrypted string
    let safeEncryptedData = encryptedData.replace(/\//g, '_slash_');
    safeEncryptedData = safeEncryptedData.replace(/\+/g, '_plus_');
    safeEncryptedData = safeEncryptedData.replace(/\%/g, '_percentage_');


    // Encode the modified encrypted data to be URL-safe
    const encodedEncryptedData = encodeURIComponent(safeEncryptedData);

    // Construct the final URL
    const newUrl = `${this.baseUrl}user-evaluation/evaluation/${encodedEncryptedData}`;
    return newUrl;
  }
}
